module.exports = __webpack_public_path__ + "static/media/banner-2.4e709557.jpeg";